import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, delay, map, throwError } from 'rxjs';
import { LoadingService } from '../../services/loading/loading.service';
import { ErrorService } from '../services/error/error.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const excludeRoutes: string[] = [];

    if (excludeRoutes.some((route) => req.url.includes(route))) {
        return next(req);
    }

    const _loading = inject(LoadingService);
    const errorService = inject(ErrorService);
    _loading.setLoading(true, req.url);

    return next(req).pipe(
        catchError((err) => {
            _loading.setLoading(false, req.url);
            errorService.handleError(err);
            return throwError(() => err);
        }),
        map((evt: HttpEvent<unknown>) => {
            if (evt instanceof HttpResponse) {
                _loading.setLoading(false, req.url);
            }
            return evt;
        }),
        delay(0),
    );
};
